var _defs, _path, _path2, _path3, _path4, _rect, _path5, _text, _path6, _path7, _path8, _path9, _rect2, _path10, _text2, _path11, _path12, _rect3, _path13, _br, _text3, _path14, _path15, _ellipse, _path16, _text4, _path17, _path18, _text5, _path19, _path20, _text6, _path21, _path22, _path23, _text7, _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabaseDevOps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "720px",
    height: "192px",
    viewBox: "-0.5 -0.5 720 192",
    content: "<mxfile host=\"Electron\" modified=\"2022-03-17T03:10:43.848Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/16.5.1 Chrome/96.0.4664.110 Electron/16.0.7 Safari/537.36\" etag=\"7vMlj0iEcB4B1gerDr05\" version=\"16.5.1\" type=\"device\"><diagram id=\"NMekppFTetZtWCQ79z2F\" name=\"Page-1\">7Vhdb9owFP01PBaFGAI8lo92k1oJrZW2PSETu4lXxzdzHAr99bOJQ76g0ArUVisPCB9f3zj3nHND3ELjaHUtcRzeAqG85Tpk1UKTluv2PaS/DbDOAG8wyIBAMpJBnQK4Y8/Ugo5FU0ZoUglUAFyxuAr6IAT1VQXDUsJTNewBePWqMQ5oA7jzMW+iPxlRYYYO3H6Bf6MsCPMrd7xhNhPhPNjeSRJiAk8lCE1baCwBVPYrWo0pN7XL65Ktu9ozu92YpEIds0B89yHCP6b8WYxvR85cEPAv7G0kap3fMCX6/u0QpAohAIH5tEBHElJBqMnq6FERcwMQa7CjwT9UqbUlE6cKNBSqiNtZvWG5/mXXbwa/zaDdy4eTVXlysi6PZlSyiCoqLZgoLNWlYVoDAoTZYbM0tloJpNKnL9TDilPnDKh6Ic7N4kyxShewhb+moHco1zpAUo4VW1bFhK0mg21cQZv+YZl7BYs27xLz1F6J0OV8JtkSK3qv6y9nPE0aVEOqOBN0vLWOqSfBSbgld0mlYtoMN3hB+QwSphgIPbcApSAqBVxyFpgJZSQwwnbk6/obosrkaxvE5vrRKjANo42fEtSO1slfPieLOROaT2EoGj0wzsfAQW42i9xpH40GGtfLCNOJ87lDnJst0tWLLOWzfWtV26vcgR0/Fc73LBSWTO91tXTPxGynwdpnM+jbzegeaUb0oczoNsyYYvVlxteaset8ODOiBrOxBLKDWo/rzYwWUv8K1LYcX2TvJdvrfTiye/9x4+0e2Xg7p268m6X6zxxelwJiYEIlpcwzA5TFU9EO6rg18rOEhRS2O3u7OrqNVjChS8oh1tWv6yb3XRrxS18Z57zV3SWl7Owgp2i7qOpENGw6Ee1yonMmH3qNSt/5ksWqUeZyp1MSHmmtTdW6muP0hxNP47zGwbZ17iMpYoRs7H5kC34AoazjtTT3UJfE2GciuN80igvPLivt92rzMZGPVPlhvqzW0/UmaYTjdpLV6CSScA8rYrhDEb1zKWLwpYj3VkTjRanfdnvvq4phQxWf/gFOBTnZwUZ+dnbokT44yyO98cx264+ZjtvW799o2EFOF3X7fa+aMbs/m6R8yFXLW39r2OTtOduPW02blaOR9lT/EvJDzK9W9W6tqucefrM4UZ/Sw+I0N5NQcSSOpv8A</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 340 32.25 L 373.63 32.25",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 378.88 32.25 L 371.88 35.75 L 373.63 32.25 L 371.88 28.75 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 210 33.59 L 210 36.39 C 210 37.3 207.3 38.2 205.73 38.5 C 201.15 39.58 193.94 39.41 190.56 38.59 C 188.82 38.23 185.8 37.32 185.8 36.41 L 185.8 33.56 C 185.88 32.64 188.67 31.61 191.54 31.19 C 195.76 30.6 199.82 30.61 203.32 31.05 C 205.86 31.31 209.97 32.43 210 33.59 Z M 210 39.25 L 210 61.43 C 209.82 62.28 206.37 63.35 204.91 63.53 C 199.89 64.41 193.78 64.5 189.21 63.38 C 187.69 63 185.79 62.21 185.8 61.31 L 185.8 39.02 C 186.75 39.79 188.38 40.48 191.3 41.04 C 194.65 41.7 200.53 41.74 204.79 40.96 C 207.04 40.58 208.97 39.91 210 39.25 Z M 184.44 62.94 L 160.17 62.94 C 154.92 62.94 150 58.4 150 52.77 L 150 10.08 C 150 4.4 155.05 0 160.12 0 L 199.61 0 C 206.24 0 210 5.51 210 10.37 L 210 30.28 C 208.49 29.49 205.41 28.68 202.54 28.4 C 197.45 27.83 191.98 28.09 188.26 28.88 C 185.82 29.37 182.52 30.5 182.52 31.52 L 182.52 58.58 C 182.52 59.22 183.61 60.02 184.44 60.31 Z",
    fill: "#2e73b8",
    stroke: "none",
    pointerEvents: "all"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 210 27.77 L 210 30.28 C 208.49 29.47 205.41 28.7 202.54 28.4 C 197.46 27.85 191.99 28.09 188.26 28.88 C 185.83 29.37 182.52 30.5 182.52 31.52 L 182.52 29.03 C 182.52 27.92 186.18 26.71 189.26 26.19 C 193.69 25.48 198.84 25.42 203.14 25.97 C 205.86 26.3 208.28 26.94 210 27.77 Z M 210 33.59 L 210 36.39 C 210 37.3 207.31 38.2 205.73 38.5 C 201.15 39.57 193.93 39.43 190.56 38.59 C 188.82 38.23 185.8 37.32 185.8 36.41 L 185.8 33.56 C 185.8 34.62 189.49 35.56 191.24 35.89 C 195.41 36.67 200.91 36.59 205.42 35.74 C 207.4 35.35 210 34.42 210 33.59 Z M 210 58.55 L 210 61.43 C 209.82 62.28 206.37 63.35 204.91 63.53 C 199.91 64.38 193.78 64.5 189.21 63.38 C 187.69 63 185.79 62.19 185.8 61.31 L 185.8 58.49 C 185.8 59.51 188.43 60.4 190.06 60.74 C 194.17 61.5 198.94 61.57 204.29 60.8 C 207.05 60.4 209.85 59.36 210 58.55 Z M 184.44 60.31 L 184.44 62.94 L 160.17 62.94 C 154.94 62.94 150 58.38 150 52.77 L 150 50.16 C 150 55.99 155.08 60.31 160.17 60.31 Z",
    fillOpacity: 0.3,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 0,
    width: 0,
    height: 0,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 191.37 17.16 C 191.87 16.8 191.99 15.95 192.07 15.21 C 192.18 14.04 192.18 11.4 192.04 10.58 C 191.95 9.9 191.78 9.12 191.18 8.86 C 190.66 8.67 190.08 8.77 189.79 8.95 C 189.43 9.21 189.27 9.64 189.18 10.02 C 188.9 11.29 188.96 13.78 189.02 14.95 C 189.11 16.25 189.35 16.83 189.67 17.1 C 190.11 17.5 190.91 17.5 191.37 17.16 Z M 169.26 7.16 L 169.26 18.88 L 167.11 18.88 L 167.11 9.44 L 165.08 18.88 L 163.04 18.88 L 161.01 9.47 L 161 18.88 L 158.84 18.88 L 158.84 7.16 L 162.36 7.16 L 164.05 15.45 L 165.76 7.16 Z M 176.86 10 L 174.7 18.38 C 174.17 20.28 173.85 21.26 172.89 21.64 C 172.25 21.88 171.3 21.85 170.41 21.84 L 170.41 20.14 L 171.09 20.14 C 171.93 20.14 172.24 19.62 172.31 18.86 L 169.83 10 L 172.1 10 L 173.46 16.13 L 174.59 10 Z M 183.31 10.46 C 183.31 9.99 183.29 9.49 182.95 9.08 C 182.57 8.67 181.51 8.62 181.03 9.15 C 180.66 9.55 180.59 10.32 180.86 10.87 C 181.25 11.56 182.16 11.76 183.31 12.31 C 183.99 12.63 185.06 13.01 185.65 13.95 C 186.13 14.65 186.21 16.39 185.63 17.5 C 185.08 18.58 183.9 19.29 181.63 19.23 C 180.08 19.15 179.06 18.67 178.53 17.57 C 178.29 17.04 178.17 16.31 178.22 15.36 L 180.59 15.36 C 180.56 16.48 180.82 17 181.28 17.23 C 182.01 17.54 182.95 17.48 183.35 16.75 C 183.69 16.18 183.63 15.12 182.99 14.68 C 182.11 13.95 180.82 13.87 179.68 13.13 C 179.06 12.67 178.25 12.05 178.32 10.14 C 178.35 8.79 178.97 7.56 180.57 7.1 C 181.48 6.86 182.87 6.83 183.96 7.3 C 185.3 7.94 185.63 9.09 185.57 10.46 Z M 194.98 19 L 193.5 20.37 L 192.15 18.89 C 191.51 19.15 190.44 19.18 189.59 19.02 C 187.95 18.71 187.22 17.62 186.92 16.01 C 186.68 14.68 186.6 12.31 186.87 10.26 C 187.07 8.85 187.63 7.54 189.08 7.06 C 190.15 6.69 191.68 6.78 192.49 7.13 C 193.88 7.71 194.31 9.05 194.5 10.4 C 194.68 11.78 194.68 13.89 194.52 15.53 C 194.37 16.54 194.09 17.26 193.73 17.74 Z M 202.11 18.88 L 195.54 18.88 L 195.54 7.16 L 197.92 7.16 L 197.92 16.95 L 202.11 16.95 Z M 191.47 58.44 L 191.47 43.47 L 195.11 43.47 L 197.7 54.5 L 200.3 43.47 L 203.94 43.47 L 203.94 58.44 L 201.66 58.44 L 201.66 46.11 L 198.73 58.44 L 196.69 58.44 L 193.75 46.09 L 193.75 58.44 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 72,
      marginLeft: 180
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "dev_PrivateTutorPlus")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 84,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "dev_Privat...")))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 440 32.28 L 535 32.28 L 623.63 32.25",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 628.88 32.25 L 621.88 35.75 L 623.63 32.25 L 621.88 28.75 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 440 33.59 L 440 36.39 C 440 37.3 437.3 38.2 435.73 38.5 C 431.15 39.58 423.94 39.41 420.56 38.59 C 418.82 38.23 415.8 37.32 415.8 36.41 L 415.8 33.56 C 415.88 32.64 418.67 31.61 421.54 31.19 C 425.76 30.6 429.82 30.61 433.32 31.05 C 435.86 31.31 439.97 32.43 440 33.59 Z M 440 39.25 L 440 61.43 C 439.82 62.28 436.37 63.35 434.91 63.53 C 429.89 64.41 423.78 64.5 419.21 63.38 C 417.69 63 415.79 62.21 415.8 61.31 L 415.8 39.02 C 416.75 39.79 418.38 40.48 421.3 41.04 C 424.65 41.7 430.53 41.74 434.79 40.96 C 437.04 40.58 438.97 39.91 440 39.25 Z M 414.44 62.94 L 390.17 62.94 C 384.92 62.94 380 58.4 380 52.77 L 380 10.08 C 380 4.4 385.05 0 390.12 0 L 429.61 0 C 436.24 0 440 5.51 440 10.37 L 440 30.28 C 438.49 29.49 435.41 28.68 432.54 28.4 C 427.45 27.83 421.98 28.09 418.26 28.88 C 415.82 29.37 412.52 30.5 412.52 31.52 L 412.52 58.58 C 412.52 59.22 413.61 60.02 414.44 60.31 Z",
    fill: "#2e73b8",
    stroke: "none",
    pointerEvents: "all"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 440 27.77 L 440 30.28 C 438.49 29.47 435.41 28.7 432.54 28.4 C 427.46 27.85 421.99 28.09 418.26 28.88 C 415.83 29.37 412.52 30.5 412.52 31.52 L 412.52 29.03 C 412.52 27.92 416.18 26.71 419.26 26.19 C 423.69 25.48 428.84 25.42 433.14 25.97 C 435.86 26.3 438.28 26.94 440 27.77 Z M 440 33.59 L 440 36.39 C 440 37.3 437.31 38.2 435.73 38.5 C 431.15 39.57 423.93 39.43 420.56 38.59 C 418.82 38.23 415.8 37.32 415.8 36.41 L 415.8 33.56 C 415.8 34.62 419.49 35.56 421.24 35.89 C 425.41 36.67 430.91 36.59 435.42 35.74 C 437.4 35.35 440 34.42 440 33.59 Z M 440 58.55 L 440 61.43 C 439.82 62.28 436.37 63.35 434.91 63.53 C 429.91 64.38 423.78 64.5 419.21 63.38 C 417.69 63 415.79 62.19 415.8 61.31 L 415.8 58.49 C 415.8 59.51 418.43 60.4 420.06 60.74 C 424.17 61.5 428.94 61.57 434.29 60.8 C 437.05 60.4 439.85 59.36 440 58.55 Z M 414.44 60.31 L 414.44 62.94 L 390.17 62.94 C 384.94 62.94 380 58.38 380 52.77 L 380 50.16 C 380 55.99 385.08 60.31 390.17 60.31 Z",
    fillOpacity: 0.3,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 0,
    width: 0,
    height: 0,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 421.37 17.16 C 421.87 16.8 421.99 15.95 422.07 15.21 C 422.18 14.04 422.18 11.4 422.04 10.58 C 421.95 9.9 421.78 9.12 421.18 8.86 C 420.66 8.67 420.08 8.77 419.79 8.95 C 419.43 9.21 419.27 9.64 419.18 10.02 C 418.9 11.29 418.96 13.78 419.02 14.95 C 419.11 16.25 419.35 16.83 419.67 17.1 C 420.11 17.5 420.91 17.5 421.37 17.16 Z M 399.26 7.16 L 399.26 18.88 L 397.11 18.88 L 397.11 9.44 L 395.08 18.88 L 393.04 18.88 L 391.01 9.47 L 391 18.88 L 388.84 18.88 L 388.84 7.16 L 392.36 7.16 L 394.05 15.45 L 395.76 7.16 Z M 406.86 10 L 404.7 18.38 C 404.17 20.28 403.85 21.26 402.89 21.64 C 402.25 21.88 401.3 21.85 400.41 21.84 L 400.41 20.14 L 401.09 20.14 C 401.93 20.14 402.24 19.62 402.31 18.86 L 399.83 10 L 402.1 10 L 403.46 16.13 L 404.59 10 Z M 413.31 10.46 C 413.31 9.99 413.29 9.49 412.95 9.08 C 412.57 8.67 411.51 8.62 411.03 9.15 C 410.66 9.55 410.59 10.32 410.86 10.87 C 411.25 11.56 412.16 11.76 413.31 12.31 C 413.99 12.63 415.06 13.01 415.65 13.95 C 416.13 14.65 416.21 16.39 415.63 17.5 C 415.08 18.58 413.9 19.29 411.63 19.23 C 410.08 19.15 409.06 18.67 408.53 17.57 C 408.29 17.04 408.17 16.31 408.22 15.36 L 410.59 15.36 C 410.56 16.48 410.82 17 411.28 17.23 C 412.01 17.54 412.95 17.48 413.35 16.75 C 413.69 16.18 413.63 15.12 412.99 14.68 C 412.11 13.95 410.82 13.87 409.68 13.13 C 409.06 12.67 408.25 12.05 408.32 10.14 C 408.35 8.79 408.97 7.56 410.57 7.1 C 411.48 6.86 412.87 6.83 413.96 7.3 C 415.3 7.94 415.63 9.09 415.57 10.46 Z M 424.98 19 L 423.5 20.37 L 422.15 18.89 C 421.51 19.15 420.44 19.18 419.59 19.02 C 417.95 18.71 417.22 17.62 416.92 16.01 C 416.68 14.68 416.6 12.31 416.87 10.26 C 417.07 8.85 417.63 7.54 419.08 7.06 C 420.15 6.69 421.68 6.78 422.49 7.13 C 423.88 7.71 424.31 9.05 424.5 10.4 C 424.68 11.78 424.68 13.89 424.52 15.53 C 424.37 16.54 424.09 17.26 423.73 17.74 Z M 432.11 18.88 L 425.54 18.88 L 425.54 7.16 L 427.92 7.16 L 427.92 16.95 L 432.11 16.95 Z M 421.47 58.44 L 421.47 43.47 L 425.11 43.47 L 427.7 54.5 L 430.3 43.47 L 433.94 43.47 L 433.94 58.44 L 431.66 58.44 L 431.66 46.11 L 428.73 58.44 L 426.69 58.44 L 423.75 46.09 L 423.75 58.44 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 72,
      marginLeft: 410
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "uat_PrivateTutorPlus")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 84,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "uat_Privat...")))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 690 33.59 L 690 36.39 C 690 37.3 687.3 38.2 685.73 38.5 C 681.15 39.58 673.94 39.41 670.56 38.59 C 668.82 38.23 665.8 37.32 665.8 36.41 L 665.8 33.56 C 665.88 32.64 668.67 31.61 671.54 31.19 C 675.76 30.6 679.82 30.61 683.32 31.05 C 685.86 31.31 689.97 32.43 690 33.59 Z M 690 39.25 L 690 61.43 C 689.82 62.28 686.37 63.35 684.91 63.53 C 679.89 64.41 673.78 64.5 669.21 63.38 C 667.69 63 665.79 62.21 665.8 61.31 L 665.8 39.02 C 666.75 39.79 668.38 40.48 671.3 41.04 C 674.65 41.7 680.53 41.74 684.79 40.96 C 687.04 40.58 688.97 39.91 690 39.25 Z M 664.44 62.94 L 640.17 62.94 C 634.92 62.94 630 58.4 630 52.77 L 630 10.08 C 630 4.4 635.05 0 640.12 0 L 679.61 0 C 686.24 0 690 5.51 690 10.37 L 690 30.28 C 688.49 29.49 685.41 28.68 682.54 28.4 C 677.45 27.83 671.98 28.09 668.26 28.88 C 665.82 29.37 662.52 30.5 662.52 31.52 L 662.52 58.58 C 662.52 59.22 663.61 60.02 664.44 60.31 Z",
    fill: "#2e73b8",
    stroke: "none",
    pointerEvents: "all"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 690 27.77 L 690 30.28 C 688.49 29.47 685.41 28.7 682.54 28.4 C 677.46 27.85 671.99 28.09 668.26 28.88 C 665.83 29.37 662.52 30.5 662.52 31.52 L 662.52 29.03 C 662.52 27.92 666.18 26.71 669.26 26.19 C 673.69 25.48 678.84 25.42 683.14 25.97 C 685.86 26.3 688.28 26.94 690 27.77 Z M 690 33.59 L 690 36.39 C 690 37.3 687.31 38.2 685.73 38.5 C 681.15 39.57 673.93 39.43 670.56 38.59 C 668.82 38.23 665.8 37.32 665.8 36.41 L 665.8 33.56 C 665.8 34.62 669.49 35.56 671.24 35.89 C 675.41 36.67 680.91 36.59 685.42 35.74 C 687.4 35.35 690 34.42 690 33.59 Z M 690 58.55 L 690 61.43 C 689.82 62.28 686.37 63.35 684.91 63.53 C 679.91 64.38 673.78 64.5 669.21 63.38 C 667.69 63 665.79 62.19 665.8 61.31 L 665.8 58.49 C 665.8 59.51 668.43 60.4 670.06 60.74 C 674.17 61.5 678.94 61.57 684.29 60.8 C 687.05 60.4 689.85 59.36 690 58.55 Z M 664.44 60.31 L 664.44 62.94 L 640.17 62.94 C 634.94 62.94 630 58.38 630 52.77 L 630 50.16 C 630 55.99 635.08 60.31 640.17 60.31 Z",
    fillOpacity: 0.3,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 0,
    width: 0,
    height: 0,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 671.37 17.16 C 671.87 16.8 671.99 15.95 672.07 15.21 C 672.18 14.04 672.18 11.4 672.04 10.58 C 671.95 9.9 671.78 9.12 671.18 8.86 C 670.66 8.67 670.08 8.77 669.79 8.95 C 669.43 9.21 669.27 9.64 669.18 10.02 C 668.9 11.29 668.96 13.78 669.02 14.95 C 669.11 16.25 669.35 16.83 669.67 17.1 C 670.11 17.5 670.91 17.5 671.37 17.16 Z M 649.26 7.16 L 649.26 18.88 L 647.11 18.88 L 647.11 9.44 L 645.08 18.88 L 643.04 18.88 L 641.01 9.47 L 641 18.88 L 638.84 18.88 L 638.84 7.16 L 642.36 7.16 L 644.05 15.45 L 645.76 7.16 Z M 656.86 10 L 654.7 18.38 C 654.17 20.28 653.85 21.26 652.89 21.64 C 652.25 21.88 651.3 21.85 650.41 21.84 L 650.41 20.14 L 651.09 20.14 C 651.93 20.14 652.24 19.62 652.31 18.86 L 649.83 10 L 652.1 10 L 653.46 16.13 L 654.59 10 Z M 663.31 10.46 C 663.31 9.99 663.29 9.49 662.95 9.08 C 662.57 8.67 661.51 8.62 661.03 9.15 C 660.66 9.55 660.59 10.32 660.86 10.87 C 661.25 11.56 662.16 11.76 663.31 12.31 C 663.99 12.63 665.06 13.01 665.65 13.95 C 666.13 14.65 666.21 16.39 665.63 17.5 C 665.08 18.58 663.9 19.29 661.63 19.23 C 660.08 19.15 659.06 18.67 658.53 17.57 C 658.29 17.04 658.17 16.31 658.22 15.36 L 660.59 15.36 C 660.56 16.48 660.82 17 661.28 17.23 C 662.01 17.54 662.95 17.48 663.35 16.75 C 663.69 16.18 663.63 15.12 662.99 14.68 C 662.11 13.95 660.82 13.87 659.68 13.13 C 659.06 12.67 658.25 12.05 658.32 10.14 C 658.35 8.79 658.97 7.56 660.57 7.1 C 661.48 6.86 662.87 6.83 663.96 7.3 C 665.3 7.94 665.63 9.09 665.57 10.46 Z M 674.98 19 L 673.5 20.37 L 672.15 18.89 C 671.51 19.15 670.44 19.18 669.59 19.02 C 667.95 18.71 667.22 17.62 666.92 16.01 C 666.68 14.68 666.6 12.31 666.87 10.26 C 667.07 8.85 667.63 7.54 669.08 7.06 C 670.15 6.69 671.68 6.78 672.49 7.13 C 673.88 7.71 674.31 9.05 674.5 10.4 C 674.68 11.78 674.68 13.89 674.52 15.53 C 674.37 16.54 674.09 17.26 673.73 17.74 Z M 682.11 18.88 L 675.54 18.88 L 675.54 7.16 L 677.92 7.16 L 677.92 16.95 L 682.11 16.95 Z M 671.47 58.44 L 671.47 43.47 L 675.11 43.47 L 677.7 54.5 L 680.3 43.47 L 683.94 43.47 L 683.94 58.44 L 681.66 58.44 L 681.66 46.11 L 678.73 58.44 L 676.69 58.44 L 673.75 46.09 L 673.75 58.44 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 72,
      marginLeft: 660
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "prod_PrivateTutorPlus", _br || (_br = /*#__PURE__*/React.createElement("br", null)))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 84,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "prod_Priva...")))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 410 140 L 45 140 L 45 32.28 L 143.63 32.25",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 148.88 32.25 L 141.88 35.75 L 143.63 32.25 L 141.88 28.75 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 425,
    cy: 117.5,
    rx: 7.5,
    ry: 7.5,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 425 125 L 425 150 M 425 130 L 410 130 M 425 130 L 440 130 M 425 150 L 410 170 M 425 150 L 440 170",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 177,
      marginLeft: 425
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Developer")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 189,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Devel...")))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 1.5 160 C 0.67 160 0 159.36 0 158.57 L 0 111.43 C 0 110.64 0.67 110 1.5 110 L 88.5 110 C 89.33 110 90 110.64 90 111.43 L 90 158.57 C 90 159.36 89.33 160 88.5 160 Z",
    fill: "#0079d6",
    stroke: "none",
    pointerEvents: "all"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 53.59 136.05 L 53.59 132.24 L 64.61 139.27 L 64.61 141.91 L 53.59 148.71 L 53.59 145.08 L 61.65 140.68 Z M 39.06 153.87 L 47.37 126.84 L 50.7 126.84 L 42.38 153.87 Z M 36.47 149.01 L 25.39 142.15 L 25.39 139.57 L 36.47 132.41 L 36.47 136.11 L 28.41 140.8 L 36.47 145.19 Z M 0.75 121.43 L 0.75 158.57 C 0.75 158.97 1.09 159.29 1.5 159.29 L 88.5 159.29 C 88.91 159.29 89.25 158.97 89.25 158.57 L 89.25 121.43 Z",
    fillOpacity: 0.5,
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 111,
      marginLeft: 45
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Script")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 123,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Script")))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 251.5 57.25 C 251.1 57.25 250.72 57.1 250.44 56.83 C 250.16 56.56 250 56.2 250 55.82 L 250 8.68 C 250 8.3 250.16 7.94 250.44 7.67 C 250.72 7.4 251.1 7.25 251.5 7.25 L 338.5 7.25 C 338.9 7.25 339.28 7.4 339.56 7.67 C 339.84 7.94 340 8.3 340 8.68 L 340 55.82 C 340 56.2 339.84 56.56 339.56 56.83 C 339.28 57.1 338.9 57.25 338.5 57.25 Z",
    fill: "#0079d6",
    stroke: "none",
    pointerEvents: "all"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 303.59 33.3 L 303.59 29.49 L 314.61 36.52 L 314.61 39.16 L 303.59 45.96 L 303.59 42.33 L 311.65 37.93 Z M 289.06 51.12 L 297.37 24.09 L 300.7 24.09 L 292.38 51.12 Z M 286.47 46.26 L 275.39 39.4 L 275.39 36.82 L 286.47 29.66 L 286.47 33.36 L 278.41 38.05 L 286.47 42.44 Z M 250.75 18.68 L 250.75 55.82 C 250.75 56.22 251.09 56.54 251.5 56.54 L 338.5 56.54 C 338.91 56.54 339.25 56.22 339.25 55.82 L 339.25 18.68 Z",
    fillOpacity: 0.5,
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 8,
      marginLeft: 295
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Script")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 295,
    y: 20,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Script")))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 210 32.28 L 230.03 32.28 L 250 32.25",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 501.5 50 C 501.1 50 500.72 49.85 500.44 49.58 C 500.16 49.31 500 48.95 500 48.57 L 500 1.43 C 500 1.05 500.16 0.69 500.44 0.42 C 500.72 0.15 501.1 0 501.5 0 L 588.5 0 C 588.9 0 589.28 0.15 589.56 0.42 C 589.84 0.69 590 1.05 590 1.43 L 590 48.57 C 590 48.95 589.84 49.31 589.56 49.58 C 589.28 49.85 588.9 50 588.5 50 Z",
    fill: "#0079d6",
    stroke: "none",
    pointerEvents: "all"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 553.59 26.05 L 553.59 22.24 L 564.61 29.27 L 564.61 31.91 L 553.59 38.71 L 553.59 35.08 L 561.65 30.68 Z M 539.06 43.87 L 547.37 16.84 L 550.7 16.84 L 542.38 43.87 Z M 536.47 39.01 L 525.39 32.15 L 525.39 29.57 L 536.47 22.41 L 536.47 26.11 L 528.41 30.8 L 536.47 35.19 Z M 500.75 11.43 L 500.75 48.57 C 500.75 48.76 500.83 48.94 500.97 49.08 C 501.11 49.21 501.3 49.29 501.5 49.29 L 588.5 49.29 C 588.7 49.29 588.89 49.21 589.03 49.08 C 589.17 48.94 589.25 48.76 589.25 48.57 L 589.25 11.43 Z",
    fillOpacity: 0.5,
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 1,
      marginLeft: 545
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFFFFF; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Script")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 545,
    y: 13,
    fill: "#FFFFFF",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Script"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseDevOps);
export default __webpack_public_path__ + "static/media/Database-DevOps.4cc5deeb80b7f4b286bb6082476d8cac.svg";
export { ForwardRef as ReactComponent };